/**
 * Species skin details: elemental
 */
import { shadeColor } from '../../../../core/color.js';

export function drawSpecies_ignis(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Mạch lửa magma nứt nẻ rực sáng dưới lớp da đỏ
  ctx.strokeStyle = '#f97316';
  ctx.lineWidth = 3.5;
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.95);
  ctx.lineTo(size * 0.46, size * 0.58);
  ctx.lineTo(size * 0.3, size * 0.32);
  ctx.moveTo(size * 0.46, size * 0.58);
  ctx.lineTo(size * 0.7, size * 0.28);
  ctx.stroke();

  ctx.strokeStyle = '#fef08a';
  ctx.lineWidth = 1.6;
  ctx.stroke();
}

export function drawSpecies_bionic(ctx, size, options = {}, skinColor = options.skinColor || '#fcd5b5') {
  // Rãnh cấy ghép titan và vi mạch nano phát sáng dưới da
  ctx.fillStyle = shadeColor(skinColor, -35);
  ctx.fillRect(size * 0.3, size * 0.45, size * 0.4, size * 0.22);

  ctx.strokeStyle = '#0284c7';
  ctx.lineWidth = 2;
  ctx.strokeRect(size * 0.3, size * 0.45, size * 0.4, size * 0.22);

  // Cổng jack cắm nano phát quang xanh ngọc
  ctx.fillStyle = '#00f0ff';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.56, 3.5, 0, Math.PI * 2);
  ctx.fill();

  ctx.strokeStyle = '#38bdf8';
  ctx.lineWidth = 1.2;
  ctx.beginPath();
  ctx.moveTo(size * 0.3, size * 0.56);
  ctx.lineTo(size * 0.15, size * 0.75);
  ctx.moveTo(size * 0.7, size * 0.56);
  ctx.lineTo(size * 0.85, size * 0.75);
  ctx.stroke();
}

export function drawSpecies_cryo(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Tinh thể tuyết rạn nứt kết tinh khúc xạ ánh lam ngọc
  ctx.strokeStyle = '#bae6fd';
  ctx.lineWidth = 1.8;
  for (let a = 0; a < 6; a++) {
    const rad = (a * 60 * Math.PI) / 180;
    ctx.beginPath();
    ctx.moveTo(size * 0.5, size * 0.52);
    ctx.lineTo(size * 0.5 + Math.cos(rad) * 26, size * 0.52 + Math.sin(rad) * 26);
    ctx.stroke();
  }
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.52, 2.5, 0, Math.PI * 2);
  ctx.fill();
}

export function drawSpecies_drakonis(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Vảy rồng lục giác chìm tinh tế trên mu bàn tay
  ctx.strokeStyle = 'rgba(127, 29, 29, 0.55)';
  ctx.lineWidth = 1.4;
  const drawHex = (cx, cy, r) => {
    ctx.beginPath();
    for (let i = 0; i < 6; i++) {
      const a = (i * 60 * Math.PI) / 180;
      const x = cx + r * Math.cos(a);
      const y = cy + r * Math.sin(a);
      if (i === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
    }
    ctx.closePath();
    ctx.stroke();
  };
  [-15, 0, 15].forEach((dx) => {
    [-14, 0, 14].forEach((dy) => {
      drawHex(size * 0.5 + dx, size * 0.5 + dy, 7.5);
    });
  });
}

export function drawSpecies_ocean(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Đốm phát quang sinh học ngọc bích óng ánh
  [
    [0.32, 0.4],
    [0.68, 0.44],
    [0.5, 0.62],
    [0.35, 0.72],
    [0.65, 0.74]
  ].forEach((pt) => {
    ctx.fillStyle = 'rgba(45, 212, 191, 0.85)';
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], 4, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], 1.5, 0, Math.PI * 2);
    ctx.fill();
  });
}

export function drawSpecies_mycelium(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Đốm bào tử nấm dạ quang xanh lá xốp nhẹ
  [
    [0.38, 0.38],
    [0.62, 0.42],
    [0.45, 0.64],
    [0.62, 0.68]
  ].forEach((pt) => {
    ctx.fillStyle = 'rgba(74, 222, 128, 0.80)';
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], 4.5, 0, Math.PI * 2);
    ctx.fill();
  });
}

export function drawSpecies_synapse(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Đường xung điện thần kinh synapse tím phát sáng
  ctx.strokeStyle = '#c084fc';
  ctx.lineWidth = 1.8;
  ctx.beginPath();
  ctx.moveTo(size * 0.25, size * 0.75);
  ctx.quadraticCurveTo(size * 0.45, size * 0.45, size * 0.75, size * 0.3);
  ctx.stroke();
  ctx.fillStyle = '#f5d0fe';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.5, 3, 0, Math.PI * 2);
  ctx.fill();
}

export function drawSpecies_ossified(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Đường vân nứt rạn canxi hóa thạch cổ xưa
  ctx.strokeStyle = '#a8a29e';
  ctx.lineWidth = 1.6;
  ctx.beginPath();
  ctx.moveTo(size * 0.35, size * 0.25);
  ctx.lineTo(size * 0.55, size * 0.55);
  ctx.lineTo(size * 0.4, size * 0.85);
  ctx.moveTo(size * 0.55, size * 0.55);
  ctx.lineTo(size * 0.75, size * 0.65);
  ctx.stroke();
}

export function drawSpecies_aurora(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Sóng quang phổ cực quang lượn nhẹ
  const aGrad = ctx.createLinearGradient(0, size * 0.3, size, size * 0.7);
  aGrad.addColorStop(0, 'rgba(52, 211, 153, 0.35)');
  aGrad.addColorStop(1, 'rgba(192, 132, 252, 0.35)');
  ctx.fillStyle = aGrad;
  ctx.beginPath();
  ctx.ellipse(size * 0.5, size * 0.55, size * 0.32, size * 0.16, Math.PI * 0.15, 0, Math.PI * 2);
  ctx.fill();
}

export function drawSpecies_cyclopia(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Chấm sao & vòng quỹ đạo vi mô của hành tinh tinh cầu
  ctx.strokeStyle = 'rgba(56, 189, 248, 0.45)';
  ctx.lineWidth = 1.2;
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.52, 16, 0, Math.PI * 2);
  ctx.stroke();
  ctx.fillStyle = '#38bdf8';
  [
    [0.42, 0.44],
    [0.58, 0.6],
    [0.5, 0.52]
  ].forEach((pt) => {
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], 1.8, 0, Math.PI * 2);
    ctx.fill();
  });
}

export function drawSpecies_quantum(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Trường dao động hạt lượng tử vi mô trên da
  ctx.fillStyle = 'rgba(14, 165, 233, 0.5)';
  [
    [0.35, 0.4],
    [0.65, 0.45],
    [0.5, 0.65]
  ].forEach((pt) => {
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], 2.2, 0, Math.PI * 2);
    ctx.fill();
  });
  ctx.strokeStyle = 'rgba(56, 189, 248, 0.35)';
  ctx.lineWidth = 1;
  ctx.strokeRect(size * 0.42, size * 0.48, size * 0.16, size * 0.16);
}

export function drawSpecies_sylva(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Gân lá xanh non thảo mộc sinh học chìm dưới mu bàn tay
  ctx.strokeStyle = '#a3e635';
  ctx.lineWidth = 1.6;
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.9);
  ctx.lineTo(size * 0.5, size * 0.35);
  ctx.moveTo(size * 0.5, size * 0.65);
  ctx.lineTo(size * 0.32, size * 0.45);
  ctx.moveTo(size * 0.5, size * 0.5);
  ctx.lineTo(size * 0.68, size * 0.35);
  ctx.stroke();
}

export function drawSpecies_insect(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Vảy kitin đa giác màu hổ phách chìm
  ctx.strokeStyle = 'rgba(245, 158, 11, 0.6)';
  ctx.lineWidth = 1.4;
  [-12, 12].forEach((dx) => {
    ctx.strokeRect(size * 0.5 + dx - 6, size * 0.45, 12, 12);
    ctx.strokeRect(size * 0.5 + dx - 6, size * 0.62, 12, 12);
  });
}

export function drawSpecies_venom(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Giọt dịch vi mô ngọc lục bảo trong mờ
  [
    [0.35, 0.4],
    [0.65, 0.45],
    [0.48, 0.62],
    [0.38, 0.72]
  ].forEach((pt) => {
    ctx.fillStyle = 'rgba(52, 211, 153, 0.8)';
    ctx.beginPath();
    ctx.arc(size * pt[0], size * pt[1], 3.5, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(size * pt[0] - 1, size * pt[1] - 1, 1.2, 0, Math.PI * 2);
    ctx.fill();
  });
}

export function drawSpecies_dune(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Nếp sóng cồn cát sa mạc chìm mịn
  ctx.strokeStyle = 'rgba(253, 224, 71, 0.5)';
  ctx.lineWidth = 1.5;
  [0.35, 0.52, 0.68].forEach((yPos) => {
    ctx.beginPath();
    ctx.moveTo(size * 0.2, size * yPos);
    ctx.quadraticCurveTo(size * 0.5, size * (yPos - 0.05), size * 0.8, size * yPos);
    ctx.stroke();
  });
}

export function drawSpecies_seraph(ctx, size, options = {}, _skinColor = options.skinColor || '#fcd5b5') {
  // Dải hào quang quang học thanh khiết tỏa tia sáng vàng kim
  const sGrad = ctx.createRadialGradient(size * 0.5, size * 0.52, 2, size * 0.5, size * 0.52, 24);
  sGrad.addColorStop(0, 'rgba(254, 240, 138, 0.9)');
  sGrad.addColorStop(0.5, 'rgba(250, 204, 21, 0.4)');
  sGrad.addColorStop(1, 'rgba(254, 240, 138, 0)');
  ctx.fillStyle = sGrad;
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.52, 24, 0, Math.PI * 2);
  ctx.fill();

  ctx.strokeStyle = '#fef08a';
  ctx.lineWidth = 1.2;
  for (let a = 0; a < 8; a++) {
    const rad = (a * 45 * Math.PI) / 180;
    ctx.beginPath();
    ctx.moveTo(size * 0.5, size * 0.52);
    ctx.lineTo(size * 0.5 + Math.cos(rad) * 22, size * 0.52 + Math.sin(rad) * 22);
    ctx.stroke();
  }
}

export const elemental_species_drawers = {
  species_ignis: drawSpecies_ignis,
  species_bionic: drawSpecies_bionic,
  species_cryo: drawSpecies_cryo,
  species_drakonis: drawSpecies_drakonis,
  species_ocean: drawSpecies_ocean,
  species_mycelium: drawSpecies_mycelium,
  species_synapse: drawSpecies_synapse,
  species_ossified: drawSpecies_ossified,
  species_aurora: drawSpecies_aurora,
  species_cyclopia: drawSpecies_cyclopia,
  species_quantum: drawSpecies_quantum,
  species_sylva: drawSpecies_sylva,
  species_insect: drawSpecies_insect,
  species_venom: drawSpecies_venom,
  species_dune: drawSpecies_dune,
  species_seraph: drawSpecies_seraph
};
